import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { CvDialogService } from 'src/app/reusables/confirm-dialog/cv-dialog.service';

@Injectable({
    providedIn: 'root'
})

export class ContextMenuAwardService {
    private BASE_URL_MANUAL_AWARDS: string = "/api/v1/gamification/manualawards";
    private BASE_URL_AWARDS: string = "/api/v1/gamification/awards";
    public dataObj = {
        params: null as any,
        modal: null as any,
        localizationMessages: new Map(), //Localization messages array
    };

    public giveAwardClicked = new BehaviorSubject<any>(null);
    public hasPermission = { GiveAward: false };

    constructor(
        private cvApiService: CVApiService,
        private localizationService: CVLocalizationService,
        private dialogService: CvDialogService
    ) {
        this.getAwardPermission().then((response: any) => {
            this.hasPermission.GiveAward = response?.data?.HasCreateAccess || false;
        });
        this.localizationService.GetSection("Manual_Awards_Context_Menu").then((result) => {
            this.dataObj.localizationMessages = result;
        });
    }

    async loadAvailableAwards(selectedRow) {
        if (selectedRow == null) {
            let title = this.getLocalizedMessage("Manual_Awards_Context_Menu", "Error");
            let msg = this.getLocalizedMessage("Manual_Awards_Context_Menu", "Error getting group data.");
            this.dialogService.showWarningDialog(title, msg);
        }

        try {
            const { groupID, groupLevel } = selectedRow;
            const url = `${this.BASE_URL_AWARDS}/groupid/${groupID}/grouplevel/${groupLevel}`;
            let response: any = await this.cvApiService.get(url);
            if (response.status_code == 200) {
                return response;
            } else {
                throw response;
            }
        } catch (error) {
            console.error("Error loading manual awards: " + error.message);
        }
    }

    getAwardPermission() {
        return this.cvApiService.get(`${this.BASE_URL_MANUAL_AWARDS}/permission`)
    }
    
    async giveAward(award, selectedRow) {
        const { groupID, groupLevel } = selectedRow;
        const url = `${this.BASE_URL_MANUAL_AWARDS}/${award.rule.RuleID}/groupId/${groupID}/groupLevel/${groupLevel}/isFromDashboard/${true}/isCxOne/${false}`;
        let response: any = await this.cvApiService.post(url);
        if (response.status_code == 200) {
            return response;
        } else {
            throw response;
        }
    };

    getLocalizedMessage(key: string, fallback: string): string {
        if (this.dataObj.localizationMessages && this.dataObj.localizationMessages.has(key)) {
            return this.dataObj.localizationMessages.get(key);
        } else {
            return fallback;
        }
    }
}
